import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  gap: 20px;

  overflow-x: auto;
  -ms-overflow-style: none; /* for Internet Explorer, Edge */
  scrollbar-width: none; /* for Firefox */
  &::-webkit-scrollbar {
    display: none; /* for Chrome, Safari, and Opera */
  }
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    max-width: calc(100vw - 12px);
    gap: 12px;
  }
`;

export const Tab = styled.div<{ active: boolean }>`
  border: 1px solid
    ${({ theme, active }) =>
      active ? theme.palette.red : theme.palette.gray87};
  border-radius: 25px;
  padding: 10px 20px;
  cursor: pointer;
  transition: all 0.15s;
  color: ${({ active, theme }) =>
    active ? theme.palette.white : theme.palette.eclipse};
  background-color: ${({ active, theme }) =>
    active ? theme.palette.red : theme.palette.white};

  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
`;
